<template>
  <div class="o-card o-card__padding-small">
    <CycleForm></CycleForm>
  </div>
</template>

<script>
import CycleForm from "@/components/Cycles/CycleForm/index.vue";
export default {
  components: {
    CycleForm,
  },
};
</script>

<style></style>
